import Migrate from '../svgs/migrate.svg';
import Ci from '../svgs/ci.svg';
import Processes from '../svgs/processes.svg';

export const practices = [
  {
    img: Migrate,
    value: 'modern_software.old_migrations'
  },
  {
    img: Ci,
    value: 'modern_software.ci'
  },
  {
    img: Processes,
    value: 'modern_software.bug_tracking'
  }
];

export const devopsFeatures = [
    {
      title: 'features.integration.title',
      description: 'features.integration.description'
    },
    {
      title: 'features.board.title',
      description: 'features.board.description'
    },
    {
      title: 'features.ci.title',
      description: 'features.ci.description'
    }
];
